<template>
  <div>
    <v-text-field label="AppID" hint="虎皮椒平台获取" class="required" v-model="value.app_id" />
    <PasswordField label="AppSecret" hint="虎皮椒平台获取" class="required" v-model="value.app_secret" />
    <v-text-field label="支付网关URL" hint="虎皮椒平台获取" class="required" v-model="value.api_url" />
    <v-text-field label="店铺网站URL" hint="虎皮椒平台获取" class="required" v-model="value.website_url" />
    <v-text-field label="店铺网站名称" hint="虎皮椒平台获取" class="required" v-model="value.website_name" />
    <v-checkbox label="支持H5支付" v-model="value.is_support_h5" />
  </div>
</template>

<script>
import PasswordField from '@/components/PasswordField.vue'

export default {
  components: { PasswordField },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="less" scoped></style>
